<template>
  <v-container class="pa-5" style="max-width: 700px; margin: auto">
    <div v-if="showModal" class="modal-overlay"></div>
    <!-- Card principal -->
    <v-card elevation="23" class="pa-4 mx-auto" max-width="700px" rounded="xl">
      <!-- Encabezado -->
      <v-row
        class="mb-0 px-4"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <!-- Div para el texto -->
        <div class="text-container" style="flex: 1">
          <h5 class="font-weight-bold mb-0">
            Realiza el pago de tu póliza en 3 pasos:
          </h5>
          <br />
          <ol class="text-subtitle-1" style="color: black; padding: 0 20px">
            <li class="d-flex justify-space-between">
              <span>1.</span>
              <span>Ingresa el número de tu póliza</span>
            </li>
            <li class="d-flex justify-space-between">
              <span>2.</span>
              <span>Revisa el monto y vigencia del recibo</span>
            </li>
            <li class="d-flex justify-space-between">
              <span>3.</span>
              <span>Selecciona pagar</span>
            </li>
          </ol>
        </div>

        <!-- Div para la imagen -->
        <div class="image-container d-none d-md-block" style="flex: 0">
          <img
            src="./../../assets/img/Logotipo LS.png"
            alt="Logotipo LS"
            style="max-width: 150px; height: auto"
          />
        </div>
      </v-row>

      <!-- Línea separadora -->
      <v-divider class="my-4 mx-4"></v-divider>

      <!-- Promoción -->
      <v-row class="mb-0 px-4">
        <v-col cols="12">
          <v-card elevation="2" class="pa-3" color="#003366" dark>
            <img
              src="./../../assets/img/banner_msi.png"
              alt="Promociones"
              aspect-ratio="16/9"
              style="max-width: 100%; height: auto"
            />
          </v-card>
        </v-col>
      </v-row>

      <!-- Input de Póliza -->
      <v-row class="px-4" style="row-gap: 0px">
        <v-col cols="12">
          <h5 style="margin-bottom: 8px">Ingresa tu número de Póliza:</h5>
          <v-text-field
            v-model="numeroPoliza"
            label="Escribe tu número de Póliza"
            outlined
            dense
            type="number"
            @input="handlePolizaInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" v-if="inputFilial">
          <h5 style="margin-bottom: 8px; margin-top: -30px">
            Ingresa tu número de filial y da clic en el botón “Pagar Póliza”:
          </h5>
          <v-text-field
            v-model="numeroFilial"
            label="Escribe tu número de Filial"
            outlined
            dense
            type="number"
            @input="soloNumeros('numeroFilial')"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Botones -->
      <v-row class="text-center px-4">
        <v-col cols="4">
          <v-btn class="btn-azul-cielo" block @click="validarYBuscarPoliza"
            >Pagar Póliza</v-btn
          >
        </v-col>
        <v-col cols="4">
          <v-btn class="btn-verde" block @click="domiciliarPoliza"
            >Domiciliar Póliza</v-btn
          >
        </v-col>
        <v-col cols="4">
          <v-btn class="btn-azul" block @click="openPromotionsModal"
            >Ver Promociones</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <!-- Modal para mostrar la URL -->
    <CModal :show="showModal" :backdrop="true" size="lg" centered>
      <template #header>
        <h5>Domiciliación</h5>
      </template>
      <iframe
        v-if="modalUrl"
        :src="modalUrl"
        style="width: 100%; height: 500px; border: none"
      ></iframe>
      <template #footer>
        <v-btn class="btnCerraDimiciliar" @click="closeModal">Cerrar</v-btn>
      </template>
    </CModal>

    <Loading :isLoading="isLoading" />
    <PromotionsModal ref="promotionsModal" />
    <CaptchaModal ref="captchaModal" @captchaVerified="onCaptchaVerified" />
  </v-container>
</template>

<script>
import PromotionsModal from "./PromotionsModal.vue";
import CaptchaModal from "./CaptchaModal.vue";
import Loading from "../isep/Tools/loading.vue";

export default {
  data() {
    return {
      numeroPoliza: "",
      numeroFilial: "",
      inputFilial: false,
      validarFilial: false,
      isMediumOrLarger: window.innerWidth >= 960,
      isVisible: true,
      isLoading: false,
      captchaValidated: false,
      consultaEsFialBandera: false,
      showModal: false,
      modalUrl: "",
      vistaDomiciliar: false,
    };
  },
  components: {
    PromotionsModal,
    CaptchaModal,
    Loading,
  },
  mounted() {
    // 1) Leer parámetros "u" y "a" de la URL (Vue Router)
    const userFromQuery = this.$route.query.u || "0";
    const appFromQuery = this.$route.query.a || "0";

    // 2) Guardar en localStorage (o setear “0” si no vienen en la URL)

    localStorage.setItem("profileId", userFromQuery);
    localStorage.setItem("applicationNumber", appFromQuery);

    const query = this.$route.query;
    const cobranza =
      query.hasOwnProperty("u") && query.hasOwnProperty("a") ? "1" : "0";
    localStorage.setItem("cobranza", cobranza);
  },
  beforeDestroy() {},
  methods: {
    soloNumeros(campo) {
      this[campo] = this[campo].replace(/\D/g, "");
    },
    handlePolizaInput(value) {
      if (!value) {
        this.numeroFilial = "";
        this.inputFilial = false;
        this.consultaEsFialBandera = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.modalUrl = "";
    },
    /*async validarYBuscarPoliza() {
      if (!this.numeroPoliza) {
        this.$swal(
          "Advertencia",
          "Por favor, ingresa un número de póliza.",
          "warning"
        );
        return;
      }
      this.$refs.captchaModal.openModal();
    },*/
    async validarYBuscarPoliza() {
      if (!this.numeroPoliza) {
        this.$swal(
          "Por favor, ingresa un número de póliza.",
          "Por favor, ingresa un número de póliza.",
          "warning"
        );
        return;
      }

      // Si aún no se ha validado si es filial
      if (!this.validarFilial) {
        const response = await this.consultaEsFial();

        if (response.data.pEsFilial) {
          this.inputFilial = true; // Mostrar el campo de filial
          if (!this.numeroFilial) {
            this.$swal(
              "Advertencia",
              "Por favor, ingresa un número de filial.",
              "warning"
            );
            return; // Esperar a que se ingrese el número de filial antes de continuar
          }
        } else {
          this.inputFilial = false; // No es necesario el campo de filial
          this.$refs.captchaModal.openModal();
        }
      }

      // Abrir el modal del captcha
      this.$refs.captchaModal.openModal();

      // Una vez que el captcha sea validado
      this.$refs.captchaModal.$once("captchaVerified", async (token) => {

        // Buscar la póliza
        //await this.buscarPoliza();
      });
    },

    async onCaptchaVerified(token) {
      if(!this.vistaDomiciliar){
          await this.buscarPoliza();
          }else{
             await this.buscarPolizaDom();
          }
      //await this.buscarPoliza();
    },

    async consultaEsFial() {
      if (!this.consultaEsFialBandera && this.numeroPoliza.length > 1) {
        this.isLoading = true;
        const payload = {
          metodo: "CONSULTAESFILIAL",
          data: {
            pPoliza: this.numeroPoliza,
            pIdUsuario: localStorage.getItem("profileId"),
          },
        };

        try {
          const response = await this.$store.dispatch("metodoPost", payload);
          this.validarFilial = true;
          if (response.data.pEsFilial === true) {

            this.inputFilial = true;
          } else {
            this.inputFilial = false;
            this.$refs.captchaModal.openModal();
          }
          this.consultaEsFialBandera = true;
        } catch (error) {
          this.$swal(
            "Error",
            "Ocurrió un error inesperado. Inténtalo más tarde.",
            "error"
          );
        } finally {
          this.isLoading = false;
        }
      }
    },

    async buscarPoliza() {
      this.$store.dispatch("resetSelectedEndosos");
      this.isLoading = true;
      const payload = {
        metodo: "BUSCAPOLIZA",
        data: {
          pPoliza: this.numeroPoliza,
          pNumFilial: this.numeroFilial,
          pEsFilial: this.inputFilial,
          pIdUsuario: localStorage.getItem("profileId"),
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response && response.data) {
          this.$store.commit("setPolizaData", response.data);
          this.$router.push("/pago-en-linea/paso-2");
          /*if(!this.vistaDomiciliar){
          this.$router.push("/pago-en-linea/paso-2");
          }else{
            this.$router.push("/pago-en-linea/domiciliar");
          }*/
  
        } else if (response && response.errorMessage) {
          this.$swal(
            response.errorMessage,
            response.errorMessage || "No se encontraron datos de la póliza.",
            "error"
          );
        } else {
          this.$swal(
            "Error No se encontraron datos de la póliza.",
            "No se encontraron datos de la póliza.",
            "error"
          );
        }
      } catch (error) {
        this.$swal({
          title: "No se encontraron datos de la póliza.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            content: "custom-swal-text",
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
     async buscarPolizaDom() {
      this.$store.dispatch("resetSelectedEndosos");
      this.isLoading = true;
      
      const payload = {
        metodo: "BUSCAPOLIZADOM",
        data: {
          pPoliza: this.numeroPoliza,
          pNumFilial: this.numeroFilial,
          pEsFilial: this.inputFilial === "" ? -1 : this.inputFilial,
          pIdUsuario: localStorage.getItem("profileId"),
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response && response.data) {
          this.$store.commit("setPolizaData", response.data);
          this.$router.push("/pago-en-linea/domiciliar");
        
  
        } else if (response && response.errorMessage) {
          this.$swal(
            response.errorMessage,
            response.errorMessage || "No se encontraron datos de la póliza.",
            "error"
          );
        } else {
          this.$swal(
            "Error No se encontraron datos de la póliza.",
            "No se encontraron datos de la póliza.",
            "error"
          );
        }
      } catch (error) {
        this.$swal({
          title: "No se encontraron datos de la póliza.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            content: "custom-swal-text",
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    /*async domiciliarPoliza() {
      if (!this.numeroPoliza) {
        this.$swal({
          icon: "warning",
          title: "Advertencia",
          text: "Por favor, ingresa un número de póliza antes de domiciliar.",
          customClass: {
            popup: "alert-popup-custom",
            title: "alert-title-custom",
            htmlContainer: "alert-text-custom",
          },
        });

        return;
      }

      // Construcción del payload
      const payload = {
        metodo: "DOMICILIARPOLIZA",
        data: {
          pPoliza: this.numeroPoliza, // Póliza proporcionada por el usuario
          pIdUsuario: localStorage.getItem("profileId") || "0", // Usuario obtenido del querystring o valor por defecto
        },
      };

      this.isLoading = true;

      try {
        // Llamada al store para realizar la consulta
        const response = await this.$store.dispatch("metodoPost", payload);

        if (response && response.data && response.flag) {

          // Asignar el enlace al data para usarlo en el modal
          this.modalUrl = response.data;
          this.showModal = true; // Mostrar el modal
        } else {
          this.$swal(
            response.errorMessage ||
              "No se pudo iniciar la domiciliación. Inténtalo nuevamente.",
            "Error",
            "error"
          );
        }
      } catch (error) {
        // Manejo de errores
        this.$swal(
          "Error en la Consulta",
          "Ocurrió un error al intentar iniciar la domiciliación. Inténtalo nuevamente.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },*/

    async domiciliarPolizaMantenimiento() {
      this.$router.push("/pago-en-linea/mantenimiento");
    },

    async domiciliarPoliza() {
      this.vistaDomiciliar = true;
      this.validarYBuscarPoliza();
   
 
    },
    
    closeModal() {
      this.showModal = false;
      this.modalUrl = ""; // Limpia la URL al cerrar el modal
    },

    verPromociones() {
      console.log("Ver Promociones");
    },
    openPromotionsModal() {
      this.$refs.promotionsModal.openModal();
    },
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Oscuridad */
  z-index: 1040; /* Asegúrate de que esté detrás del modal */
}
.alert-popup-custom {
  color: black !important;
}

.alert-title-custom {
  color: black !important;
}

.alert-text-custom {
  color: black !important;
}

/* Ocultar la imagen en pantallas pequeñas */
.image-container {
  display: flex;
}
.text-promocion {
  font-size: 8px;
}

.btn-azul-cielo {
  background-color: #87ceeb !important; /* Azul cielo */
  color: white !important;
}

.btn-verde {
  background-color: #28a745 !important; /* Verde */
  color: white !important;
}

.btn-azul {
  background-color: #003366 !important; /* Azul oscuro */
  color: white !important;
}
.btnCerraDimiciliar {
  background-color: #e40d0db8 !important; /* Azul oscuro */
  color: white !important;
}
.custom-swal-popup {
  font-family: Arial, sans-serif;
}

.custom-swal-title {
  color: #333 !important; /* Negro oscuro */
}

.custom-swal-text {
  color: #000 !important; /* Negro */
}

@media (max-width: 960px) {
  .image-container {
    display: none;
  }

  .text-container {
    flex: 1 !important;
  }
  .text-promocion-titulo {
    font-size: 8px;
  }
  .text-promocion {
    font-size: 4px;
  }
  .btn-primary {
    background-color: #003366;
    color: white;
  }

  .btn-success {
    background-color: #28a745;
    color: white;
  }

  .btn-info {
    background-color: #17a2b8;
    color: white;
  }
  .image-promo-container {
    width: 30px;
  }
}
</style>